import { Fragment } from 'react';

import HeadTitle from '@/components/ui/custom/HeadTitle';
import Layout from '@/components/template/Layout';
import useAuth from '@/data/hook/useAuth';
import { UserTypeEnum } from '@/models/User';
import AdminDashboardView from './AdminDashboardView';
import StudentDashboardView from './student/StudentDashboardView';
import TeacherDashboardViewSwitcher from './TeacherDashboardViewSwitcher';

export default function DashboardPage() {
  const { user } = useAuth();

  return (
    <Layout>
      <HeadTitle />
      <RenderViewByRole role={user?.userType} />
    </Layout>
  );
}

interface RenderViewByRoleProps {
  role?: UserTypeEnum;
}

const RenderViewByRole = ({ role }: RenderViewByRoleProps) => {
  switch (role) {
    case UserTypeEnum.STUDENT:
      return <StudentDashboardView />;
    case UserTypeEnum.SUPER_ADMIN:
      return <AdminDashboardView />;
    case UserTypeEnum.UNIT_ADMIN:
      return <AdminDashboardView />;
    case UserTypeEnum.TEACHER:
      return <TeacherDashboardViewSwitcher />;
    default:
      return <Fragment />;
  }
};
